import i18n from 'i18n';
import {
  parseSpaceHealthState,
  SpaceHealthState,
  SPACE_HEALTH_STATUS_I18N
} from 'enum/SpaceHealthState';
import { HEALTH_STATE_ICON } from 'components/common/Tags/Tags';
import { Status } from 'components/Status/Status';

type DeviceStatusChipProps = {
  /** 後端送來的原始值（大寫）。 */
  healthState: string;
  unitKey: string;
};

/**
 * 後端字串換成畫面狀態一律走 `parseSpaceHealthState`，不要在這裡自己比對字串 ——
 * 少了它，後端的英文原字串會直接漏到畫面上。
 *
 * 認不得的值（含 SSP 有、PMax 刻意忽略的那幾個）解出來是 undefined，這時呈現為
 * 正常，與廣告活動版位選擇器的聚合結果（utils/spaceHealth.ts）一致。
 */
export const resolveDeviceHealthState = (
  healthState: string
): SpaceHealthState =>
  parseSpaceHealthState(healthState) ?? SpaceHealthState.NORMAL;

export const HEALTH_STATE_STATUS_COLOR: Record<SpaceHealthState, string> = {
  [SpaceHealthState.BANNED]: 'danger',
  [SpaceHealthState.WARMING_UP]: 'warning',
  [SpaceHealthState.NO_DATA]: 'danger',
  [SpaceHealthState.NORMAL]: 'success'
};

/**
 * POS-8145：外觀走系統共用的 `Status`，與其他列表的狀態欄一致；文案與圖示沿用
 * 版位選擇器那一套（`SPACE_HEALTH_STATUS_I18N` / `HEALTH_STATE_ICON`）。
 *
 * chip 只寫狀態本身，不掛 hover 提示：狀態說明在詳情面板，最後回報時間是清單自己的一欄。
 */
export const DeviceStatusChip: React.FC<DeviceStatusChipProps> = ({
  healthState,
  unitKey
}) => {
  const state = resolveDeviceHealthState(healthState);

  return (
    <div data-testid={`status-chip-${unitKey}`}>
      <Status
        color={HEALTH_STATE_STATUS_COLOR[state]}
        label={i18n.t(SPACE_HEALTH_STATUS_I18N[state])}
        icon={HEALTH_STATE_ICON[state]}
      />
    </div>
  );
};
